import React, { useEffect, useRef, useState } from 'react';
import './index.module.less';

import NavBar from '@components/NavBar';
import CommonBtn from '@components/CommonBtn';
import Toast from '@widgets/Toast';
import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';
import { isCubeApp } from '@helpers/Constants';
import { getNativeProxySington } from '@helpers/NativeProxy';
import FridayService from '@services/friday';
import iconLocation from './images/icon_location.png';
import iconDesc from './images/icon_desc.png';
import iconContact from './images/icon_contact.png';
import BrowserHistory from '@helpers/BrowserHistory';

const LocationFeedBack = () => {

  const [textAreaCount, setTextCount] = useState(0);
  const [textLocationCount, setLocationTextCount] = useState(0);
  const [location, setLocation] = useState('');
  const [description, setDescription] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const isEmpty = (value: string) => {
    return (!value || value.length === 0);
  }

  const params = useRef(Filter.urlParams(window.location.search));

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextCount(event.target.value.length);
  }

  const handleLocationChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setLocationTextCount(event.target.value.length);
  }

  const readLocationText = (event: React.FocusEvent<HTMLTextAreaElement>) => {
      setLocation(event.target.value)
  }

  const readDespText = (event: React.FocusEvent<HTMLTextAreaElement>) => {
    setDescription(event.target.value);
  }

  const readPhoneText = (event: React.FocusEvent<HTMLInputElement>) => {
    setPhoneNumber(event.target.value);
  }

  const submit = () => {
    FridayService.addEvent('feedback_submit_button_click')

    const regexNumber = new RegExp('^[0-9]+$');

    if (isEmpty(description)) {
      Toast.show({
        type: 'strip-bottom',
        title: '请输入问题描述'
      })
    } else if (isEmpty(phoneNumber)) {
      Toast.show({
        type: 'strip-bottom',
        title: '请输入联系方式'
      })
    } else if (phoneNumber.length < 11 || !regexNumber.test(phoneNumber)) {
      Toast.show({
        type: 'strip-bottom',
        title: '请输入 11 位数字'
      })
    } else {
      Http.post(Api.PostDeviceLocationFeedback,
        { snCode: params.current.sncode || params.current.snCode,
          company: params.current.company,
          recordUid: params.current.recordUid || '',
          position: location || '',
          desc: description,
          contact: phoneNumber }
      ).then(async () => {
        Toast.show({
          type: 'strip-bottom',
          title: '提交成功'
        });
        
        if(isCubeApp()) {
          const np = await getNativeProxySington('seewoCube')
          await np.asyncInvoke({
            name: 'postMessage',
            params: {
              command: 'command_close_container',
              extras: {}
            }
          })
        } else {
          setTimeout(() => {
            BrowserHistory.goBack();
          }, 500);
        }
      })
      .catch(e => {});
    }
  }
  useEffect(() => {
    if (isEmpty(params.current.phone)) {
      FridayService.addEvent('feedback_page_itself_display', { source:  '消息通知' });
    } else {
      FridayService.addEvent('feedback_page_itself_display', { source: '智能安全守护'});
    }

    var areaText = '';
    if (!isEmpty(params.current.location)) {
      areaText += decodeURI(params.current.location);
    }
    if (!isEmpty(params.current.detail)) {
      areaText += isEmpty(params.current.location) ? decodeURI(params.current.detail) : `\n${decodeURI(params.current.detail)}`;
    }
    setLocation(areaText);
    setLocationTextCount(areaText.length);

    if (!isEmpty(params.current.phone)) {
      setPhoneNumber(params.current.phone);
    }
  },[]);

  return (
    <div styleName="container" style={{ height: document.body.clientHeight }}>
      <NavBar
        title="反馈定位问题"
      />
      <div className="flex" styleName='item-card' style={{ paddingTop: '1.7rem'}}>
        <div styleName="item-title">
            <img styleName='icon' src={iconLocation} alt=''/>
            <span>{ '问题地点' }</span>
        </div>
        <div styleName='item-card-text'>
              <textarea styleName='text-input-area' placeholder='请输入具体地点' maxLength={100} onChange={handleLocationChange} onBlur={readLocationText} defaultValue={location} />
              <p styleName='text-count'>{`${textLocationCount}/100`}</p>
        </div>
      </div>

      <div className="flex" styleName='item-card'>
        <div styleName="item-title">
            <img styleName='icon' src={iconDesc} alt=''/>
            <span>{ '问题描述' }</span>
        </div>
        <div styleName='item-card-text'>
          <textarea styleName='text-input-area' placeholder='如该地点不是危险区域' maxLength={200} onChange={handleChange} onBlur={readDespText}/>
          <p styleName='text-count'>{`${textAreaCount}/200`}</p>
        </div>
      </div>

      <div className="flex" styleName='item-card' style={{ paddingBottom: '1.8rem' }}>
        <div styleName="item-title">
            <img styleName='icon' src={iconContact} alt=''/>
            <span>{ '联系方式' }</span>
        </div>
        <div styleName='phone-card-text'>
          <input placeholder='请输入手机号' maxLength={11} defaultValue={phoneNumber} onBlur={readPhoneText}/>
        </div>
      </div>
      <div styleName="bottom-button">
        <CommonBtn
          style={{height: '.96rem'}}
          type="auto"
          btnText="提 交"
          onConfirm={submit}
        />
      </div>
    </div>
  )
}

export default LocationFeedBack;
